// Keys are normalized names (lowercase, singular). Extend over time.
export const GROCERY_SEED = {
    // produce
    tomato: "produce",
    "roma tomato": "produce",
    onion: "produce",
    garlic: "produce",
    potato: "produce",
    carrot: "produce",
    "bell pepper": "produce",
    pepper: "produce",
    spinach: "produce",
    lettuce: "produce",
    banana: "produce",
    apple: "produce",
    lemon: "produce",
    lime: "produce",
    avocado: "produce",
    mushroom: "produce",
    "cherry tomato": "produce",
    scallion: "produce",
    cilantro: "produce",
    parsley: "produce",
    ginger: "produce",
    "bok choy": "produce",
    plantain: "produce",
    // meat & seafood
    chicken: "meat-seafood",
    "chicken thigh": "meat-seafood",
    "chicken breast": "meat-seafood",
    beef: "meat-seafood",
    "chuck roast": "meat-seafood",
    pork: "meat-seafood",
    bacon: "meat-seafood",
    turkey: "meat-seafood",
    salmon: "meat-seafood",
    "sea bass": "meat-seafood",
    shrimp: "meat-seafood",
    pancetta: "meat-seafood",
    // dairy & eggs
    milk: "dairy-eggs",
    egg: "dairy-eggs",
    butter: "dairy-eggs",
    cheese: "dairy-eggs",
    yogurt: "dairy-eggs",
    cream: "dairy-eggs",
    mascarpone: "dairy-eggs",
    feta: "dairy-eggs",
    ricotta: "dairy-eggs",
    pecorino: "dairy-eggs",
    "cream cheese": "dairy-eggs",
    // bakery
    bread: "bakery",
    tortilla: "bakery",
    ladyfinger: "bakery",
    "pizza dough": "bakery",
    bun: "bakery",
    // pantry
    flour: "pantry",
    sugar: "pantry",
    salt: "pantry",
    "olive oil": "pantry",
    oil: "pantry",
    rice: "pantry",
    pasta: "pantry",
    "black bean": "pantry",
    chickpea: "pantry",
    lentil: "pantry",
    "canned tomato": "pantry",
    "tomato paste": "pantry",
    stock: "pantry",
    broth: "pantry",
    "soy sauce": "pantry",
    honey: "pantry",
    "cocoa powder": "pantry",
    yeast: "pantry",
    oat: "pantry",
    hummus: "pantry",
    miso: "pantry",
    mirin: "pantry",
    sake: "pantry",
    "chipotle in adobo": "pantry",
    "white miso": "pantry",
    // frozen
    "frozen pea": "frozen",
    "ice cream": "frozen",
    // beverages
    coffee: "beverages",
    espresso: "beverages",
    wine: "beverages",
    juice: "beverages",
    // household
    "paper towel": "household",
    "dish soap": "household",
    "trash bag": "household",
};
export function seedCategory(normalizedName) {
    return GROCERY_SEED[normalizedName] ?? null;
}
//# sourceMappingURL=grocery-seed.js.map